import { Component } from '@angular/core';

@Component({
  selector: 'ala-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
})
export class SocialLinksComponent {}
